"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var codegen_1 = require("./codegen");
var rust_1 = require("./rust");
var Python = /** @class */ (function (_super) {
    __extends(Python, _super);
    function Python() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Python.prototype.getSafeTitle = function (title) {
        var n = _super.prototype.getSafeTitle.call(this, title);
        // Remove all non-capitalized-alpha characters before the first capitalized alpha character.
        return n.replace(/^[^A-Z]+/m, "");
    };
    Python.prototype.generate = function (s, ir) {
        return [
            ir.documentationComment,
            "\n",
            ir.typing,
        ].join("");
    };
    Python.prototype.handleBoolean = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", bool)",
            imports: ["from typing import NewType"],
        };
    };
    Python.prototype.handleNull = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", None)",
            imports: ["from typing import NewType"]
        };
    };
    Python.prototype.handleNumber = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", float)",
            imports: ["from typing import NewType"]
        };
    };
    Python.prototype.handleInteger = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", int)",
            imports: ["from typing import NewType"]
        };
    };
    Python.prototype.handleNumericalEnum = function (s) {
        this.warnNotWellSupported("numericalEnum");
        if (s.type === "integer") {
            return this.handleInteger(s);
        }
        else {
            return this.handleNumber(s);
        }
    };
    Python.prototype.handleString = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", str)",
            imports: ["from typing import NewType"]
        };
    };
    Python.prototype.handleStringEnum = function (s) {
        var sEnum = s.enum;
        var typeLines = sEnum
            .filter(function (enumString) { return typeof enumString === "string"; })
            .map(function (enumString, i) { return "    " + rust_1.enumIdentifierFromTitle(enumString) + " = " + i; });
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: __spreadArray([
                "class " + title + "(Enum):"
            ], typeLines).join("\n"),
            imports: ["from enum import Enum"]
        };
    };
    Python.prototype.handleOrderedArray = function (s) {
        var _this = this;
        var title = this.getSafeTitle(s.title);
        var sItems = s.items;
        var itemTitles = sItems.map(function (item) { return _this.getSafeTitle(_this.refToTitle(item)); });
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", Tuple[" + itemTitles.join(", ") + "])",
            imports: [
                "from typing import NewType",
                "from typing import Tuple"
            ]
        };
    };
    Python.prototype.handleUnorderedArray = function (s) {
        var title = this.getSafeTitle(s.title);
        var itemsTitle = this.getSafeTitle(this.refToTitle(s.items));
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", List[" + itemsTitle + "])",
            imports: [
                "from typing import List",
                "from typing import NewType"
            ]
        };
    };
    Python.prototype.handleUntypedArray = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", List[Any])",
            imports: [
                "from typing import List",
                "from typing import Any",
                "from typing import NewType"
            ]
        };
    };
    Python.prototype.handleObject = function (s) {
        var _this = this;
        var sProps = s.properties;
        var propertyTypings = Object.keys(sProps).reduce(function (typings, key) {
            var propSchema = sProps[key];
            var isRequired = false;
            var propTitle = _this.refToTitle(propSchema);
            if (s.required) {
                isRequired = s.required.indexOf(propTitle) !== -1;
            }
            var safeTitle = _this.getSafeTitle(propTitle);
            // first expression of right hand side
            var rhs = isRequired ? title : "Optional[" + safeTitle + "]";
            return __spreadArray(__spreadArray([], typings), ["    " + key + ": " + rhs]);
        }, []);
        if (s.additionalProperties) {
            this.warnNotWellSupported("ObjectsWithAdditionalProperties");
            return this.handleUntypedObject(s);
        }
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: __spreadArray([
                "class " + title + "(TypedDict):"
            ], propertyTypings).join("\n"),
            imports: [
                "from typing import TypedDict",
                "from typing import Optional"
            ]
        };
    };
    Python.prototype.handleUntypedObject = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", Mapping[Any, Any])",
            imports: [
                "from typing import NewType",
                "from typing import Any",
                "from typing import Mapping"
            ]
        };
    };
    Python.prototype.handleAnyOf = function (s) {
        var title = this.getSafeTitle(s.title);
        var sAny = s.anyOf;
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: title + " = NewType(\"" + title + "\", Union[" + this.getJoinedSafeTitles(sAny, ", ") + "])",
            imports: [
                "from typing import NewType",
                "from typing import Union"
            ]
        };
    };
    Python.prototype.handleAllOf = function (s) {
        this.warnNotWellSupported("allOf");
        // note - this doesnt work because subschemas are fully reffd when they get here
        // so pulling out the properties and merging them isn't gonna fly.
        // in TS this is made easy by the `& ` operator which afaik there is no equiv in py
        // here is the code that doesnt work, leaving it here to demonstrate the desired outcome
        // const copy = { ...s };
        // const sAll = s.allOf as JSONSchema[];
        // copy.properties = mergeObjectProperties(sAll);
        // return this.handleObject(copy);
        return this.handleUntypedObject(s);
    };
    Python.prototype.handleOneOf = function (s) {
        var title = this.getSafeTitle(s.title);
        var sOne = s.oneOf;
        return {
            documentationComment: this.buildDocs(s),
            prefix: "type",
            typing: title + " = NewType(\"" + title + "\", Union[" + this.getJoinedSafeTitles(sOne, ", ") + "])",
            imports: [
                "from typing import NewType",
                "from typing import Union"
            ]
        };
    };
    Python.prototype.handleConstantBool = function (s) {
        var t = "Always" + (s === true ? "True" : "False");
        return {
            typing: t + " = NewType(\"" + t + "\", Any)",
            imports: [
                "from typing import NewType",
                "from typing import Any"
            ]
        };
    };
    Python.prototype.handleUntyped = function (s) {
        var title = this.getSafeTitle(s.title);
        return {
            documentationComment: this.buildDocs(s),
            typing: title + " = NewType(\"" + title + "\", Any)",
            imports: [
                "from typing import NewType",
                "from typing import Any"
            ]
        };
    };
    Python.prototype.warnNotWellSupported = function (typing) {
        console.warn("In Python, " + typing + " is not well supported.");
    };
    Python.prototype.buildDocs = function (s) {
        var docStringLines = [];
        if (s.description) {
            docStringLines.push("" + s.description);
            docStringLines.push("");
        }
        if (docStringLines.length > 0) {
            return [
                "\"\"\"" + s.description,
                "\"\"\"",
            ].join("\n");
        }
    };
    return Python;
}(codegen_1.CodeGen));
exports.default = Python;
